'use client';

import { useAtomValue } from '@effect/atom-react';
import type { ListingScopeKey } from '@vs-shop/engine/capability/productListing/listingScope';
import * as AsyncResult from 'effect/unstable/reactivity/AsyncResult';
import { useIntl } from 'react-intl';

import { rcprofiListingJourney } from '../../../effect/listing/listingJourney';

type Props = {
  readonly query: string;
  readonly fallbackCount: number;
  readonly scopeKey: ListingScopeKey;
};

/** The search heading follows the same result as the product grid. */
export const ListingSearchHeading = ({ query, fallbackCount, scopeKey }: Props) => {
  const intl = useIntl();
  const current = useAtomValue(rcprofiListingJourney.bind(scopeKey).current);
  const count = AsyncResult.isSuccess(current) ? current.value.products.total : fallbackCount;

  return intl.formatMessage(
    {
      id: 'container.search.search.heading',
      defaultMessage: 'Výsledky pro <q>{query}</q> ({count})',
    },
    { query, count, q: (chunks) => <strong>{chunks}</strong> }
  );
};
